// src/components/copilot/ChatMessages.jsx
import { Alert, Box } from "@mui/material";
import { memo, useRef, useEffect } from "react";
import ChatMessage from "./ChatMessage";
import ChatWelcome from "./ChatWelcome";
import ChatLoadingIndicator from "./ChatLoadingIndicator";

const ChatMessages = memo(
  ({
    messages,
    isLoading,
    error,
    onErrorClose,
    profileContext,
    onSendMessage,
    onSaveStructuredData,
  }) => {
    const messagesEndRef = useRef(null);

    useEffect(() => {
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages]);

    return (
      <Box
        sx={{
          flex: 1,
          overflow: "auto",
          p: 2,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        {error && (
          <Alert severity="error" onClose={onErrorClose}>
            {error}
          </Alert>
        )}

        {messages.length === 0 && (
          <ChatWelcome
            profileContext={profileContext}
            onSendMessage={onSendMessage}
          />
        )}

        {messages.map((msg, i) => (
          <ChatMessage
            key={i}
            message={msg}
            onSaveStructuredData={onSaveStructuredData}
            onSendMessage={onSendMessage}
          />
        ))}

        {isLoading && messages[messages.length - 1]?.role === "user" && (
          <ChatLoadingIndicator />
        )}

        <div ref={messagesEndRef} />
      </Box>
    );
  },
);

ChatMessages.displayName = "ChatMessages";

export default ChatMessages;
